module.exports = __webpack_public_path__ + "static/img/floorEveryBottom.0ec91023.png";